/** How long each slide stays up before the next one. */
export const SLIDE_DURATION_MS = 4500;

/** The outgoing slide's exit; the next mounts after it. */
export const SLIDE_TRANSITION_MS = 300;
